import Rollbar from 'rollbar';

const baseConfig = {
  captureUncaught: true,
  captureUnhandledRejections: true,
  // Disable all auto-instrumentation (network, DOM, navigation) to prevent
  // infinite recursion when Rollbar intercepts its own outgoing requests.
  // `captureNetwork` is NOT a valid Rollbar 2.x option — use autoInstrument.
  autoInstrument: {
    network: false,
    log: false,
    dom: false,
    navigation: false,
    connectivity: false,
  },
  environment: process.env.NODE_ENV,
  enabled: true,
  verbose: process.env.NODE_ENV === 'development',
  // Filter out browser extension and non-critical errors
  checkIgnore: function(isUncaught: boolean, args: any[], item: any) {
    // Check both .message and .description — Rollbar payload uses .description for the full text
    const message = item?.body?.trace?.exception?.message ||
                   item?.body?.trace?.exception?.description ||
                   item?.body?.message?.body || 
                   '';
    
    // Filter browser extension errors and non-critical warnings
    if (typeof message === 'string') {
      const lowerMessage = message.toLowerCase();
      
      if (lowerMessage.includes('object not found matching id') ||
          lowerMessage.includes('methodname:update') ||
          lowerMessage.includes('resizeobserver loop completed') ||
          lowerMessage.includes('script error') ||
          lowerMessage.includes('loading chunk') ||
          lowerMessage.includes('loading css chunk') ||
          lowerMessage.includes('chunkloaderror') ||
          // Ignore stack overflow errors from Rollbar itself
          lowerMessage.includes('maximum call stack size exceeded') ||
          // Ignore React hydration errors
          lowerMessage.includes('hydration') ||
          lowerMessage.includes('text content does not match') ||
          lowerMessage.includes('hydration failed') ||
          lowerMessage.includes('hydration mismatch') ||
          lowerMessage.includes('did not match') ||
          lowerMessage.includes('minified react error') ||
          lowerMessage.includes('reactdom.hydrate') ||
          lowerMessage.includes('server rendered html') ||
          lowerMessage.includes('client rendered html') ||
          lowerMessage.includes('socket server did not execute the callback')
          ) {
        return true; // Ignore this error
      }
    }
    
    // Also check the stack trace for Rollbar-related recursion and third-party scripts
    const frames = item?.body?.trace?.frames || [];
    const argsStack = (args || [])
      .map((a: any) => (a && typeof a === 'object' && a.stack) || (typeof a === 'string' ? a : ''))
      .join(' ');
    const stack = [
      frames.map((f: any) => f.filename || '').join(' '),
      item?.body?.trace?.exception?.stack || '',
      argsStack,
    ].join(' ');
    const lowerStack = stack.toLowerCase();

    // Ignore errors originating from browser extensions (e.g. Urban VPN, ad blockers)
    if (
      lowerStack.includes('chrome-extension://') ||
      lowerStack.includes('moz-extension://') ||
      lowerStack.includes('safari-extension://') ||
      lowerStack.includes('safari-web-extension://') ||
      lowerStack.includes('webkit-masked-url://')
    ) {
      return true;
    }

    if (stack.includes('rollbar') && message.includes('Maximum call stack size exceeded')) {
      return true; // Ignore Rollbar recursion errors
    }
    
    // Check for React hydration errors in the stack trace
    if (lowerStack.includes('hydration') || lowerStack.includes('react-dom')) {
      const lowerMessage = (message || '').toLowerCase();
      if (lowerMessage.includes('mismatch') || lowerMessage.includes('did not match')) {
        return true; // Ignore hydration errors
      }
    }
    
    return false; // Don't ignore
  }
};

export const clientConfig = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  ...baseConfig,
};

export const serverInstance = new Rollbar({
  accessToken: process.env.ROLLBAR_SERVER_TOKEN,
  ...baseConfig,
});

